import React, { useState } from 'react';
import api from '../../../utils/api';
import { Dialog } from '@headlessui/react';
import { useNavigate } from 'react-router-dom';

const Settings = ({ user }) => {
  const navigate = useNavigate();
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [deleteSuccess, setDeleteSuccess] = useState(false);

  const handleDeleteAccount = async () => {
    try {
      await api.delete(`/api/users/${user.id}`);
      setDeleteSuccess(true);
    } catch (err) {
      console.error(err);
      alert('Error al eliminar la cuenta');
    }
  };

  return (
    <div className="space-y-10">
      <div>
        <h3 className="text-lg font-semibold text-gray-900 mb-2">Borrar Cuenta</h3>
        <p className="text-sm text-gray-700">
          Si decides eliminar tu cuenta, perderás todos los datos asociados. Esta acción es irreversible.
        </p>
        <button
          onClick={() => setShowConfirmModal(true)}
          className="mt-3 text-red-600 hover:underline font-medium"
        >
          Eliminar cuenta
        </button>
      </div>

      {/* Modal de confirmación */}
      <Dialog open={showConfirmModal} onClose={() => setShowConfirmModal(false)} className="relative z-50">
        <div className="fixed inset-0 bg-black/40 flex items-center justify-center">
          <Dialog.Panel className="bg-white rounded-xl p-6 w-full max-w-md shadow-xl">
            {!deleteSuccess ? (
              <>
                <Dialog.Title className="text-lg font-semibold text-gray-900">¿Estás seguro?</Dialog.Title>
                <p className="text-sm text-gray-600 mt-2">
                  Esta acción eliminará permanentemente tu cuenta y no podrá deshacerse.
                </p>
                <div className="mt-6 flex justify-end gap-2">
                  <button
                    onClick={() => setShowConfirmModal(false)}
                    className="px-4 py-2 border border-gray-300 rounded hover:bg-gray-50"
                  >
                    Cancelar
                  </button>
                  <button
                    onClick={handleDeleteAccount}
                    className="px-4 py-2 bg-red-600 text-white rounded hover:bg-red-700"
                  >
                    Eliminar Cuenta
                  </button>
                </div>
              </>
            ) : (
              <>
                <Dialog.Title className="text-lg font-semibold text-gray-900">
                  Cuenta eliminada correctamente
                </Dialog.Title>
                <div className="mt-4 flex justify-end">
                  <button
                    onClick={() => navigate('/clientes')}
                    className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700"
                  >
                    Volver
                  </button>
                </div>
              </>
            )}
          </Dialog.Panel>
        </div>
      </Dialog>
    </div>
  );
};

export default Settings;
